import { z } from 'zod';

/**
 * Anuncios da equipa de streaming (GS12, parte A). Sem Discord: o Stream Staff
 * publica para toda a equipa ou para os afilhados de um padrinho; o padrinho
 * so para os seus. Email a cada streamer e lista no `/painel`.
 */

const datetimeSchema = z.string().datetime({ offset: true });

export const announcementSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  body: z.string(),
  /** Login de quem publicou. */
  author: z.string(),
  /** `null` = toda a equipa; senao, os afilhados deste padrinho. */
  padrinho: z.object({ accountId: z.string().uuid(), login: z.string() }).nullable(),
  createdAt: datetimeSchema,
});
export type Announcement = z.infer<typeof announcementSchema>;

/** Para o `/painel`: os anuncios que o streamer ve e quantos estao por ler. */
export const myAnnouncementsSchema = z.object({
  unread: z.number().int(),
  items: z.array(announcementSchema.extend({ unread: z.boolean() })),
});
export type MyAnnouncements = z.infer<typeof myAnnouncementsSchema>;

/**
 * `POST /api/streaming/announcements` (Stream Staff: `padrinhoId` escolhe o
 * grupo, `null` = toda a equipa) e `POST /api/streaming/padrinho/announcements`
 * (o padrinho: sempre os seus afilhados, sem `padrinhoId`).
 */
export const announcementInputSchema = z.object({
  title: z.string().trim().min(3, 'titulo curto demais').max(120),
  body: z.string().trim().min(1, 'escreve o anuncio').max(5000),
  padrinhoId: z.string().uuid().nullable().default(null),
});
export type AnnouncementInput = z.input<typeof announcementInputSchema>;
